import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';

@Component({
  selector: 'DCO-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css'],
  standalone: false,
})
export class BaseComponent implements OnInit {
  private languageManagerReady$!: Subscription;
  constructor(
    public router: Router,
    public langService: LanguageManagerService,
    private readonly activatedRoute: ActivatedRoute
  ) {}
  ngOnInit(): void {
    // this.router.events.subscribe((event)=>{
    //   if (event instanceof NavigationEnd) {
    //     let title = this.router.routerState.root.snapshot.data['title'];
    //     this.langService.TranslateTitle(title);
    //     if (title) {
    //       this.languageManagerReady$ =
    //         this.langService.languageManagerReady$.subscribe((languages) => {
    //           // cuando termina de cargar los idiomas mostramos el desplegable
    //           this.langService.TranslateTitle(title);
    //         });
    //     }
    //   }
    // });
    
    this.activatedRoute.title.subscribe({
      next: (title) => {
        // Use Page Title
        if (title) {
          this.langService.TranslateTitle(title);
          this.languageManagerReady$ =
            this.langService.languageManagerReady$.subscribe((languages) => {
              // cuando termina de cargar los idiomas mostramos el desplegable
              this.langService.TranslateTitle(title);
            });
        }
      },
    });
  }
  
  onError(error?: string) {
    var page = '/error';
    var params = {};
    if (error != null && error != undefined) {
      params['msg'] = error;
    }
    this.router.navigate([page], { queryParams: params });
  }
  onLoginRequired(callbackUrl?: string) {
    var page = '/login';
    var params = {};
    if (callbackUrl != null && callbackUrl != undefined) {
      params['callbackUrl'] = callbackUrl;
    }
    this.router.navigate([page], { queryParams: params });
  }
  onUnauthorized(callbackUrl?: string) {
    var page = '/unauthorized';
    var params = {};
    if (callbackUrl != null && callbackUrl != undefined) {
      params['callbackUrl'] = callbackUrl;
    }
    this.router.navigate([page], { queryParams: params });
  }

  getStatusMessage(response) {
    let message = '';

    const errorOcurredLogID = this.langService.translate(
      'DCO.Message_ErrorOcurredLogID'
    );
    const contactAdmin = this.langService.translate('DCO.Message_ContactAdmin');
    const errorOcurred = this.langService.translate('DCO.Message_ErrorOcurred');

    if (response.status === 404) {
      message = this.langService.translate(
        `DCO.HttpStatusMessage_${response.status.toString()}`
      );
    } else if (response.status === 500) {
      if (response.error.detail !== undefined) {
        message = `${errorOcurredLogID} ${response.error.detail}. ${contactAdmin}`;
      } else {
        message = `${errorOcurred} ${contactAdmin}`;
      }
      // console.log(response);
    } else {
      message = `${errorOcurred} ${contactAdmin}`;
    }

    return message;
  }
}
